module.exports = __webpack_public_path__ + "img/chat-text-fill.586c3aa4.svg";